import React, { type ReactNode } from 'react';

import { ModalPaddingSizes, type TextAlignments } from '../../Modal.types';

import { LayoutWrapper, SectionWrapper } from './styles';

export interface ModalLayoutProps {
    children: ReactNode;
    className?: string;
}

interface SectionProps {
    children: ReactNode;
    alignEnd?: boolean;
    textAlign?: TextAlignments;
    padded?: boolean;
    paddingSize?: ModalPaddingSizes;
}

export function ModalLayout({ children, className }: ModalLayoutProps) {
    return <LayoutWrapper className={className}>{children}</LayoutWrapper>;
}

function Section({
    children,
    alignEnd = false,
    padded = false,
    paddingSize = ModalPaddingSizes.Normal,
    textAlign = 'center',
}: SectionProps) {
    return (
        <SectionWrapper $alignEnd={alignEnd} $padded={padded} $paddingSize={paddingSize} $textAlign={textAlign}>
            {children}
        </SectionWrapper>
    );
}

ModalLayout.Section = Section;
